import { combineReducers } from 'redux'

import wordpress from './wordpress'
// Import reducers

const rootReducer = combineReducers({
  wordpress,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js